export const LOAD_PHOTOGRAPHERS_SUCCESS = 'LOAD_PHOTOGRAPHERS_SUCCESS';
export const ADD_PHOTOGRAPHER_SUCCESS = 'ADD_PHOTOGRAPHERS_SUCCESS';
export const LOAD_NEW_PHOTOGRAPHER_SUCCESS = 'LOAD_NEW_PHOTOGRAPHER_SUCCESS';
export const GET_EDIT_PHOTOGRAPHER_SUCCESS = 'GET_EDIT_PHOTOGRAPHER_SUCCESS';
export const UPDATE_PHOTOGRAPHER_SUCCESS = 'UPDATE_PHOTOGRAPHER_SUCCESS';
export const GET_PHOTOGRAPHER_CALENDAR_SUCCESS = 'GET_PHOTOGRAPHER_CALENDAR_SUCCESS';
export const CREATE_CUBICASA_CONNECTION_SUCCESS = 'CREATE_CUBICASA_CONNECTION_SUCCESS';
export const UPDATE_PHOTOGRAPHER_WORKING_HOURS_SUCCESS =
    'UPDATE_PHOTOGRAPHER_WORKING_HOURS_SUCCESS';
